import React, { Component } from 'react';
import Row from '../Row';
import Col from '../Col';
import './HomeOwnerDashboard.scss';
import EmptyImage from './EmptyImage';
import { Link } from 'react-router-dom';
import { PATHS } from '../../common/constants';
import moment from 'moment';

class WarrantyList extends Component {
    getDate=(d)=>{    
    return moment(d).format('MM/DD/YYYY')
  }
    render() {
        const { data, propertyManagerDetails, currentUserSuite } = this.props;
        return (
            <div className='homeDasboard__mainTile'>
                <div style={{ padding: 20 }}>
                       <div style={{display: 'flex'}}>
                           <div style={{width: '80%'}}>
                           <label className='homeDasboard__title'>WARRANTY STATUS</label> 
                           </div>
                           <div style={{width: '20%'}}>
                           <Link
                            
                            to={ currentUserSuite && currentUserSuite.propertyId ? {
                            pathname:PATHS.SUITES_VIEW.replace(':id',currentUserSuite.propertyId+"&"+currentUserSuite.id),
                            state:{ suite:{id: currentUserSuite.id},property:{id: currentUserSuite.propertyId}}
                            } : null}
                        >
                             <label className='homeDasboard__viewAll'>VIEW ALL</label> 
                            </Link> 
                           </div>
                       </div> 
                    
                    <div className='homeDasboard__tile'>
                    <div style={{display: 'flex'}}>
                            <div style={{width: '70%'}}>
                                <div className='homeDasboard__tableItem'>Status</div>
                            </div>
                            <div style={{width: '30%'}}>
                                <div className='homeDasboard__tableItem'>Date</div>
                            </div>
                        </div>
                        <div className='homeDasboard__list'>
                            <div className='homeDasboard__table'>
                                <div style={{display: 'flex'}}>
                                    <div style={{width: '70%'}}>
                                        <label className='homeDasboard__date'>1 Year Warranty :</label>
                                    </div>
                                    <div style={{width: '30%'}}>
                                        <label className='homeDasboard__date--digit' >{data.assetWarrantyOneYear ? this.getDate(data.assetWarrantyOneYear) : 0}</label>
                                    </div>
                                </div>
                            </div>
                                <div className='homeDasboard__table'>
                                <div style={{display: 'flex'}}>
                                <div style={{width: '70%'}}>
                                            <label className='homeDasboard__date'>2 Year Warranty :</label>
                                        </div>
                                        <div style={{width: '30%'}}>
                                            <label className='homeDasboard__date--digit' >{data.assetWarrantyTwoYear ? this.getDate(data.assetWarrantyTwoYear) : 0}</label>
                                            </div>
                                            </div>
                                </div>
                                {/* <div className='homeDasboard__table'>
                                    <div style={{display: 'flex'}}>
                                        <div style={{width: '70%'}}>
                                            <label className='homeDasboard__date'>Expired :</label>
                                        </div>
                                        <div style={{width: '30%'}}>
                                            <label className='homeDasboard__date--digit' >{data.other ? data.other : 0}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='homeDasboard__table'>
                                    <div style={{display: 'flex'}}>
                                        <div style={{width: '70%'}}>
                                            <label className='homeDasboard__date'>Expiring within 60 days :</label>
                                        </div>
                                        <div style={{width: '30%'}}>
                                            <label className='homeDasboard__date--digit' >{data.other ? data.other : 0}</label>
                                        </div>
                                    </div>
                                </div> */}
                                {/* )
                            })} */}
                        </div>
                    </div>
                    {/* : 
                    <EmptyImage 
                    text='You have no available warranties.'
                    image={"/assets/empty/documents.svg"}
                    />
                } */}
                </div>
            </div>

        )
    }
}
export default WarrantyList